import { ShieldCheck, FileCheck, ClipboardList, Award, AlertCircle, ChevronRight } from 'lucide-react';

const STEPS = [
  { step: '01', title: 'Đánh giá ban đầu', desc: 'Kiểm tra điều kiện cơ sở vật chất, quy trình sản xuất hiện tại.' },
  { step: '02', title: 'Lập kế hoạch', desc: 'Xây dựng lộ trình cải thiện phù hợp tiêu chuẩn ATFP.' },
  { step: '03', title: 'Triển khai', desc: 'Hỗ trợ thực hiện các biện pháp cải tiến, đào tạo nhân viên.' },
  { step: '04', title: 'Cấp chứng nhận', desc: 'Hoàn thiện hồ sơ và nộp cơ quan có thẩm quyền để cấp phép.' },
];
const SERVICES = [
  { icon: <ShieldCheck size={20} />, title: 'Giấy phép VSATTP', desc: 'Tư vấn và hỗ trợ xin cấp giấy chứng nhận vệ sinh an toàn thực phẩm cho nhà hàng, quán cafe, bếp cloud.' },
  { icon: <FileCheck size={20} />, title: 'Kiểm nghiệm thực phẩm', desc: 'Kết nối phòng lab kiểm nghiệm thực phẩm uy tín, kiểm tra vi sinh, hóa học theo chuẩn Bộ Y tế.' },
  { icon: <ClipboardList size={20} />, title: 'Đào tạo nhân viên', desc: 'Chương trình đào tạo kiến thức ATFP cho bếp trưởng, nhân viên chế biến theo quy định.' },
  { icon: <Award size={20} />, title: 'Chứng nhận ISO 22000', desc: 'Hỗ trợ doanh nghiệp đạt tiêu chuẩn ISO 22000 về hệ thống quản lý an toàn thực phẩm.' },
  { icon: <AlertCircle size={20} />, title: 'Kiểm tra định kỳ', desc: 'Dịch vụ audit định kỳ hàng quý để đảm bảo duy trì tiêu chuẩn ATFP liên tục.' },
  { icon: <ShieldCheck size={20} />, title: 'Giấy phép rượu bia', desc: 'Tư vấn xin cấp phép kinh doanh đồ uống có cồn, giấy phép bán lẻ rượu.' },
];

export default function DichVuHoTroATFPPage() {
  return (
    <div className="max-w-5xl mx-auto space-y-10 animate-fade-in">
      <div className="rounded-2xl overflow-hidden relative p-8 md:p-12"
           style={{ background: 'linear-gradient(135deg, #16a34a 0%, #22c55e 50%, #4ade80 100%)' }}>
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, white 1px, transparent 1px)', backgroundSize: '30px 30px' }} />
        <div className="relative z-10 flex items-start gap-5">
          <div className="w-16 h-16 rounded-2xl bg-white/20 flex items-center justify-center shrink-0">
            <ShieldCheck size={32} className="text-white" />
          </div>
          <div>
            <p className="text-white/70 text-sm font-medium mb-1">Dịch vụ hỗ trợ</p>
            <h1 className="font-display font-black text-3xl text-white mb-2">Dịch vụ hỗ trợ ATFP</h1>
            <p className="text-white/80 text-base max-w-xl">
              Hỗ trợ toàn diện về An Toàn Thực Phẩm — từ xin giấy phép, kiểm nghiệm,
              đào tạo đến đạt chuẩn quốc tế ISO 22000.
            </p>
          </div>
        </div>
      </div>

      {/* Process */}
      <div>
        <h2 className="font-display font-bold text-xl mb-5" style={{ color: 'var(--text-1)' }}>Quy trình hỗ trợ</h2>
        <div className="grid sm:grid-cols-4 gap-4">
          {STEPS.map((s, i) => (
            <div key={s.step} className="relative">
              <div className="fnb-card p-4 text-center h-full">
                <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-black text-sm mx-auto mb-3"
                     style={{ background: '#16a34a' }}>
                  {s.step}
                </div>
                <p className="font-semibold text-sm mb-1" style={{ color: 'var(--text-1)' }}>{s.title}</p>
                <p className="text-xs" style={{ color: 'var(--text-3)' }}>{s.desc}</p>
              </div>
              {i < STEPS.length - 1 && (
                <div className="hidden sm:block absolute top-1/2 -right-2 -translate-y-1/2 z-10"
                     style={{ color: '#16a34a' }}>
                  <ChevronRight size={16} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div>
        <h2 className="font-display font-bold text-xl mb-5" style={{ color: 'var(--text-1)' }}>Dịch vụ chi tiết</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map(s => (
            <div key={s.title} className="fnb-card p-5">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-3"
                   style={{ background: '#dcfce7', color: '#16a34a' }}>
                {s.icon}
              </div>
              <h3 className="font-semibold text-sm mb-2" style={{ color: 'var(--text-1)' }}>{s.title}</h3>
              <p className="text-xs leading-relaxed" style={{ color: 'var(--text-3)' }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-2xl p-6 border" style={{ background: 'var(--surface-0)', borderColor: 'var(--border-c)' }}>
        <div className="flex items-center gap-3 mb-4">
          <AlertCircle size={20} style={{ color: '#16a34a' }} />
          <h3 className="font-bold" style={{ color: 'var(--text-1)' }}>Lưu ý quan trọng</h3>
        </div>
        <ul className="space-y-2 text-sm" style={{ color: 'var(--text-2)' }}>
          {['Giấy phép VSATTP phải được gia hạn định kỳ 3 năm/lần.', 'Nhà hàng trên 200 chỗ ngồi cần kiểm nghiệm nước hàng năm.', 'Nhân viên trực tiếp chế biến thực phẩm phải có giấy khám sức khỏe.'].map(note => (
            <li key={note} className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 rounded-full mt-1.5 shrink-0" style={{ background: '#16a34a' }} />
              {note}
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-2xl p-8 text-center" style={{ background: 'var(--navbar-top)' }}>
        <h3 className="font-display font-black text-xl text-white mb-2">Kiểm tra ngay hôm nay</h3>
        <p className="text-gray-400 text-sm mb-5">Đánh giá miễn phí tình trạng ATFP của cơ sở bạn</p>
        <button className="px-8 py-3 rounded-xl font-semibold text-white" style={{ background: '#16a34a' }}>
          Đặt lịch kiểm tra miễn phí
        </button>
      </div>
    </div>
  );
}
